export const T = {
  en_GB: {
    noPortfolioCosts: "No portfolio costs configured.",
  },
  nb_NO: {
    noPortfolioCosts: "Ingen porteføljekostnader konfigurert.",
  },
} as const;
